module.exports = __webpack_public_path__ + "static/media/14-3.469bf4d6.mp3";